var map = {
	"./culik/surat-add-penduduk-min.png": "cd21",
	"./menanga/surat-add-penduduk-min.png": "ee60",
	"./remun-surat/surat-add-penduduk-min.png": "7c89",
	"./sangsit/surat-add-penduduk-min.png": "9765",
	"./sibetan/surat-add-penduduk-min.png": "687e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bee";